import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cygov-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: false,
})
export class ConfirmationModalComponent {
  @Input() message = 'Are you sure?';
  @Output() modalResult = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) {}
}
